<template>
    <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-产品-添加
    -->
    <el-dialog title="变更记录" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="50%">
        <div class="product-add pb50">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
               <el-table-column prop="name" label="变更类型"></el-table-column>   
              <el-table-column prop="content" label="变更内容"></el-table-column>
              <el-table-column prop="createtime" label="变更时间"></el-table-column>
            <el-table-column prop="editor" label="操作人"></el-table-column>   
             
             <!-- <el-table-column fixed="right" label="操作" width="190">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                  <el-button @click="passClick(scope.row)" type="text" size="small">审核通过</el-button>
                  <el-button @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
                  <el-button @click="checkRecord(scope.row)" type="text" size="small">查看变更记录</el-button>
                </template>
              </el-table-column> -->
            </el-table>
        </div>
    </el-dialog>

</template>

<script>
    import HproductApi from '@/api/hproduct.js';

    import Upload from '@/components/file/Upload';
    import Categoryas from "@/components/categorya/index.vue";
    import draggable from "vuedraggable";
    import Uediter from '@/components/UE.vue';
import { error } from 'shelljs';
    export default {
        components: {

            /*图片上传*/
            Upload: Upload,
            Categoryas,
            draggable,
            Uediter
        },
        data() {
            return {
                tableData:[
                    {
                        name:"库存变更",
                        content:"增加100库存",
                        createtime:"2024-12-16 15:29",
                        editor:"XXX"
                    }
                ],
                /*是否上传图片*/
                isupload: false,
                isImg: false,
                /*富文本配置*/
                ueditor: {
                    text: '',
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    category_id: 0,
                    name: "",
                    image: [],
                    bannar: [],
                    price: 0,
                    type: [],
                    tip: "",
                    fview: 0,
                    parameters:[],
                    limitedSize:"",
                    model:{
                        grade_model:1,
                        is_alone_grade:1,
                        
                    },
                    productType:false,
                    gradeList:[
                        {
                            name:"等级1",
                            product_fixed:0,
                            product_equity:0
                        },
                        {
                            name:"等级2",
                            product_fixed:0,
                            product_equity:0
                        },
                        {
                            name:"等级3",
                            product_fixed:0,
                            product_equity:0
                        }
                    ]
                },
                loading: false,
                /*验证规则*/
                rules: {
                    name: [{
                        required: true,
                        message: '请输入产品名称',
                        trigger: 'blur'
                    }],
                },
                dialogVisible: false,
                iscategorya: false,
                excludeIds: [],
                isProductUpload: false,
                code: "album",
                type: [],
                catgory: [],
                parameterList: [] //参数列表
            };
        },
        created() {
            this.dialogVisible = this.open_add;
            this.getSetting();
            this.getData()
        },
        props: ["open_add"],
        methods: {
            // 选择一级参数
            parameterChange(e){
                let that = this 
                let par = e
                if(that.form.parameters.length > 0){
                    that.form.parameters.forEach((v,i) => {
                        if(v.category_id != e.category_id){
                            that.form.parameters.push(e)
                            throw error("stop")
                        }
                    })
                }else{
                    that.form.parameters.push(e) 
                }
            },
            
            // 删除参数
            delPara(index){
                let that = this 
                that.form.parameters.splice(index,1)
                console.log(index)
            },
            
            // 获取参数列表
            getData() {
                let self = this;
                HproductApi.attrList({
                        supply_id: " "
                    }, true)
                    .then(data => {
                        console.log("data", data)
                        if(data.code == 1){
                            self.parameterList = data.data.list
                        }
                        // self.loading = false;
                        // self.tableData = data.data.list;
                        // self.categoryModel.catList = self.tableData;
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            getSetting() {
                var self = this;
                self.getSetting_common({
                    "item": 'hproduct',
                    "condi": ['catgory']
                }, function(data) {
                    self.type = data.vars.values.type
                    self.catgory = data.obj.catgory;
                })
            },
            delType(index) {
                this.form.type.splice(index, 1)
            },

            typeChange(e) {
                var ind = 0;
                for (var i = 0; i < this.form.type.length; i++) {
                    if (this.form.type[i].code == e.code) {
                        ind++;
                    }
                }
                if (ind <= 0) {
                    this.form.type.push(e);
                }

            },
            chooseCategory() {
                this.iscategorya = true;
            },
            /*上传*/
            openUpload(e) {
                this.isupload = true;
            },


            /*关闭弹窗*/
            dialogFormVisible(result) {
                this.$emit("close", {
                    openDialog: false,
                    "type": ""
                });
            },
            cancelFunc() { //取消
                this.dialogFormVisible("error")
            },

            onSubmit() {
                let self = this;
                let form = self.form;
                self.$refs.form.validate(valid => {
                    if (valid) {
                        self.loading = true;
                        HproductApi.add(form, true)
                            .then(data => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: 'success'
                                });
                                self.dialogFormVisible("error")
                            })
                            .catch(error => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*取消添加，返回任务列表*/
            cancelFunc() {
                this.$emit("close", {
                    openDialog: false,
                    "type": ""
                });
            },
            /*打开上传图片*/
            openProductUpload: function(code) {
                this.isProductUpload = true;
                this.code = code
            },

            /*上传商品图片*/
            returnProductImgsFunc(e) {
                if (this.code == 'album') {
                    if (e != null) {
                        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
                        let prevent = false;
                        console.log(typeof imgExpt);
                        e.forEach((element) => {
                            let data_array = element.file_path.split(".");
                            let ext = data_array[data_array.length - 1];
                            imgExpt.forEach((e) => {
                                if (e === ext) {
                                    prevent = true
                                    return false
                                }
                            });
                        });

                        if (!prevent) {
                            this.$message.error("图片类型有误,请选择正确的图片格式");
                            return false;
                        }
                        this.form.image = e[0].file_path;
                        this.$set(this.form, "image", this.form.image);
                    }
                } else {
                    if (e != null) {
                        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
                        let prevent = false;
                        console.log(typeof imgExpt);
                        e.forEach((element) => {
                            let data_array = element.file_path.split(".");
                            let ext = data_array[data_array.length - 1];
                            imgExpt.forEach((e) => {
                                if (e === ext) {
                                    prevent = true
                                    return false
                                }
                            });
                        });

                        if (!prevent) {
                            this.$message.error("图片类型有误,请选择正确的图片格式");
                            return false;
                        }

                        let imgs = this.form.bannar.concat(e);
                        this.$set(this.form, "bannar", imgs);
                    }
                }

                this.isProductUpload = false;
            },

            /*删除商品图片*/
            deleteImg(index, code) {
                if (code == 'album') {
                    this.form.image = ""
                } else if (code == 'bannar') {
                    this.form.bannar.splice(index, 1);
                }

            },

        }
    };
</script>

<style>
    .edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }


    .draggable-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper>span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>


// WEBPACK FOOTER //
// src/views/store/store/part/record.vue